/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Generic_IntroInputs */



/**
* | output |
* | --- |
* | "Configure your identity provider with SCIM 2.0 support using the following information:" |
*
* @param {Scim_Setup_Generic_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_generic_intro = /** @type {((inputs?: Scim_Setup_Generic_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Generic_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Ihren Identitätsanbieter mit SCIM 2.0-Unterstützung unter Verwendung der folgenden Informationen:")
	return /** @type {LocalizedString} */ ("Configure your identity provider with SCIM 2.0 support using the following information:")
});